import React, { useContext } from 'react';
import { useAtom } from 'jotai';

import { CustomInitContext } from '@/components/CustomTravel/CustomInit';
import SelectPassengerForm from '@/components/CustomTravel/ServiceForm/forms/SelectPassengerForm';
import { customTravelFormStateAtom } from '@/atoms/customTravelFormState';

interface SelectPassengerProps {}

const SPECIAL_NOTE_ETC_CODE = 'SN999';

const SelectPassenger: React.FC<SelectPassengerProps> = () => {
  const { customOptions } = useContext(CustomInitContext);
  const [{ groupType, personalCount, specialNote }] = useAtom(customTravelFormStateAtom);
  const { specialNotes = [] } = customOptions?.find((option) => option.groupType === groupType?.code) || {};

  const externalValues = {
    personalCount,
    specialNote: specialNote
      ? { ...specialNote, etcName: specialNote.code === SPECIAL_NOTE_ETC_CODE ? specialNote.name : undefined }
      : undefined,
  };

  return <SelectPassengerForm specialNotes={specialNotes} externalValues={externalValues} />;
};

export default SelectPassenger;
